module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-i-pad@3x.bfa572f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-i-pad@3x.png
// module id = wFjV
// module chunks = 18